import React from 'react';

import UserBoardHeader from '@/userBoard/views/UserBoardHeader';
import CasinoTabs from '@/header/CasinoTabs';

function CasinoHeader({ active }) {
    return (
        <UserBoardHeader pageFixerClassName="tabs">
            <CasinoTabs active={active} />
        </UserBoardHeader>
    );
}

export default CasinoHeader;
